import './PDFDownloadModal.css';

import * as React from 'react';
import Modal from 'src/components/Modal';
import Button from 'src/components/Button';
import Radio from 'src/components/Radio';

export interface PDFDownloadProps {
    show: boolean;
    onClose(): void;
    onDownload(isPrintDownload: boolean): void;
}

export interface PDFDownloadState {
    isPrintDownload: boolean
}

export default class PDFDownloadModal extends React.Component<PDFDownloadProps, PDFDownloadState> {
    constructor(props: PDFDownloadProps) {
        super(props);

        this.state = {
            isPrintDownload: false
        };
    }

    close() {
        this.setState({ isPrintDownload: true })
        this.props.onClose();
	}
	
	toggleisPrintDownload(value: boolean) {
		this.setState({ isPrintDownload: value });
    }
    
    onDownload() {
        this.props.onDownload(this.state.isPrintDownload);
    }

    render() {
        return(
            <Modal show={this.props.show} onClose={ () => this.close() }>
                <Modal.Header>
                    <Modal.Title>
                        <h5>Create PDF</h5>
                    </Modal.Title>
                    <Button bsClass="close" onClick={ () => this.close() }></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="pdfCreatorModalContainer">
                        <label>
                            <b>Is this PDF for print or email distribution?</b>
                        </label>
                        <Radio
                            checked={ this.state.isPrintDownload }
                            onChange={ () => this.toggleisPrintDownload(true) }
                        >
                            <span>Print</span>
                        </Radio>
                        <Radio
                            checked={ !this.state.isPrintDownload }
                            onChange={ () => this.toggleisPrintDownload(false) }
                        >
                            <span>Email</span>
                        </Radio>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                <Button bsClass="cancel" onClick={ () => { this.close() } }>
                    Cancel
                </Button>
                <Button
                    bsClass="primary"
                    onClick={ () => { this.onDownload(); } }
                >
                    Download
                </Button>
            </Modal.Footer>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Modals/PDFDownloadModal/PDFDownloadModal.tsx